export const orderBailiffAllSelector = (state) =>
  state?.orderBailiffReducer?.orderBailiffAll;
export const orderBailiffOpenAddSelector = (state) =>
  state?.orderBailiffReducer?.orderBailiffOpenAdd;
export const orderBailiffOpenEditSelector = (state) =>
  state?.orderBailiffReducer?.orderBailiffOpenEdit;
export const orderBailiffSelectedSelector = (state) =>
  state?.orderBailiffReducer?.orderBailiffSelected;
export const orderBailiffSearchSelector = (state) =>
  state?.orderBailiffReducer?.orderBailiffSearch;
//
export const orderBailiffQrSelector = (state) =>
  state?.orderBailiffReducer?.orderBailiffQR;
export const orderBailiffOpenPaymentSelector = (state) =>
  state?.orderBailiffReducer?.orderBailiffOpenPayment;
